import { useState } from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import ListItemWithIcon from '@r1-frontend/ui-react/components/List/WithIcon';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { InfoCircleFlip } from '@r1-frontend/ui-react/components/svg/main';
import { Forward, VideoAdd, VideoVertical, VoiceSquare } from '@r1-frontend/ui-react/components/svg/media';
import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { IndentContainer, ListContainer } from '@r1-frontend/ui-react/experimental/containers';

const MovixIs = (): JSX.Element => {
    const [isOpen, changePopupState] = useState(false);

    const handleClosePopup = () => {
        changePopupState(false);
    };

    const handleOpenPopup = () => {
        changePopupState(true);
    };

    return (
        <>
            <ControlElement type={'large'} Icon={InfoCircleFlip} onClick={handleOpenPopup}>Все преимущества приставки</ControlElement>

            <DefaultPopup isOpen={isOpen} onClose={handleClosePopup}>
                <IndentContainer $desktop={[32]} $mobile={[24]}>
                    <ListContainer $size={24}>
                        <ListContainer $size={16}>
                            <H3 $withIndent={false} style={{ marginRight: 45 }}>ТВ&nbsp;приставка Movix&nbsp;&mdash; это:</H3>

                            <ListContainer $size={12}>
                                <ListItemWithIcon Icon={VideoVertical}>Доступ к&nbsp;магазину с&nbsp;тысячами приложений и&nbsp;игр</ListItemWithIcon>
                                <ListItemWithIcon Icon={Forward}>До&nbsp;195&nbsp;телеканалов, перемотка и&nbsp;запись телепередач</ListItemWithIcon>
                                <ListItemWithIcon Icon={VideoAdd}>Все подписки, объединенные в&nbsp;одном личном кабинете</ListItemWithIcon>
                                <ListItemWithIcon Icon={VoiceSquare}>Голосовой поиск и&nbsp;родительский контроль</ListItemWithIcon>
                            </ListContainer>
                        </ListContainer>

                        <ButtonGroup>
                            <Button bType={'action'} size={'large'} onClick={handleClosePopup}>Закрыть</Button>
                        </ButtonGroup>
                    </ListContainer>
                </IndentContainer>
            </DefaultPopup>
        </>
    );
};

export default MovixIs;
